import React, { useState } from "react"
import PropTypes from "prop-types"
import { Icon } from "@shopify/polaris"
import { ChevronUpMinor, ChevronDownMinor } from "@shopify/polaris-icons"
import OrganizationItem from "./OrganizationItem"
import { useTranslation } from "react-i18next"

const MAX_VISIBLE = 3

const Chevron = ({ expanded }) => (
  <Icon source={expanded ? ChevronUpMinor : ChevronDownMinor} />
)

Chevron.propTypes = {
  expanded: PropTypes.bool.isRequired,
}

const ProductSection = ({
  logo: Logo,
  organizations,
  expanded,
  onToggle,
  onSelectOrg,
  currentOrgId,
  disabled,
  product,
}) => {
  const { t } = useTranslation()
  const [showAll, setShowAll] = useState(false)

  const hasMore = organizations.length > MAX_VISIBLE
  const visibleOrgs = showAll
    ? organizations
    : organizations.slice(0, MAX_VISIBLE)

  return (
    <div className={`pnav-section${disabled ? " pnav-section--disabled" : ""}`}>
      <button
        className={`pnav-section__header pnav-section__header--${product}`}
        onClick={onToggle}
        type="button"
      >
        <span className="pnav-section__logo">
          <Logo />
        </span>
        <span className="pnav-section__chevron">
          <Chevron expanded={expanded} />
        </span>
      </button>

      {expanded && (
        <div className="pnav-section__list">
          {visibleOrgs.map((org) => (
            <OrganizationItem
              key={org.id}
              organization={org}
              isActive={org.id === currentOrgId}
              onClick={() => !disabled && onSelectOrg(org, product)}
              product={product}
            />
          ))}
          {hasMore && !showAll && (
            <button
              className="pnav-section__more"
              onClick={(e) => {
                e.stopPropagation()
                setShowAll(true)
              }}
              type="button"
            >
              +{organizations.length - MAX_VISIBLE}{" "}
              {t("common:navigation.more")} &#8595;
            </button>
          )}
          {hasMore && showAll && (
            <button
              className="pnav-section__more"
              onClick={(e) => {
                e.stopPropagation()
                setShowAll(false)
              }}
              type="button"
            >
              {t("common:navigation.show_less")} &#8593;
            </button>
          )}
        </div>
      )}
    </div>
  )
}

ProductSection.propTypes = {
  logo: PropTypes.elementType.isRequired,
  organizations: PropTypes.array.isRequired,
  expanded: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
  onSelectOrg: PropTypes.func.isRequired,
  currentOrgId: PropTypes.number,
  disabled: PropTypes.bool,
  product: PropTypes.oneOf(["corporate", "provider"]).isRequired,
}

ProductSection.defaultProps = {
  currentOrgId: null,
  disabled: false,
}

export default ProductSection
